// Formato de las identificaciones de Panamá (SWIFT_TIPO_IDENTIFICACION, ID_PAIS = 2), tal cual las recibe la factura
// electrónica (con guiones). Mismas reglas que el API (src/utils/panama-id.ts). No se usan Consumidor final ni Gobierno.
//   101 Persona Natural    cédula (8-926-1601, PE-1-123, N-1-123, E-8-12345, 8AV-1-123, 8PI-1-123) o NT (3-NT-3-33)
//   102 Persona Jurídica   RUC de la empresa (155986022-2-2019) o NT
//   103 Extranjero         pasaporte o identificación extranjera (sin RUC/NT, no lleva DV)

export const PANAMA_ID_NATURAL = 101;
export const PANAMA_ID_JURIDICA = 102;
export const PANAMA_ID_EXTRANJERO = 103;

// Provincia 1–13 (con AV: antes de la vigencia, PI: población indígena), PE: panameño nacido en el extranjero,
// N: naturalizado, E: extranjero residente
const CEDULA = /^(?:(?:[1-9]|1[0-3])(?:AV|PI)?|PE|N|E)-\d{1,4}-\d{1,6}$/;
const NT = /^\d{1,2}-NT-\d{1,4}-\d{1,6}$/;
const RUC_JURIDICO = /^\d{1,10}-\d{1,4}-\d{1,7}$/;
const PASAPORTE = /^[A-Z0-9]{5,20}$/;

export const normalizePanamaId = (documentNumber: unknown) => String(documentNumber ?? '').trim().toUpperCase();

/** Mensaje de error si la identificación no tiene el formato del tipo; null si es válida. */
export const panamaIdError = (typeLegalId: unknown, documentNumber: unknown): string | null => {
    const value = normalizePanamaId(documentNumber);
    if (!value) return 'Debe indicar la identificación.';
    switch (Number(typeLegalId)) {
        case PANAMA_ID_NATURAL:
            return CEDULA.test(value) || NT.test(value) ? null : 'La cédula no tiene un formato válido (ej. 8-926-1601, PE-1-123, 3-NT-3-33).';
        case PANAMA_ID_JURIDICA:
            return RUC_JURIDICO.test(value) || NT.test(value) ? null : 'El RUC no tiene un formato válido (ej. 155986022-2-2019 o 3-NT-3-33).';
        case PANAMA_ID_EXTRANJERO:
            return PASAPORTE.test(value) ? null : 'El pasaporte debe tener de 5 a 20 letras o números, sin guiones ni espacios.';
        default:
            return 'El tipo de identificación no es válido para Panamá.';
    }
};

/** El extranjero sin RUC/NT no tiene DV. */
export const panamaIdHasDv = (typeLegalId: unknown) => Number(typeLegalId) !== PANAMA_ID_EXTRANJERO;
